import React from 'react'

const clientesRoutes = [
    {
        path: '/configuracoes/provedores',
        exact: true,
        component: React.lazy(() => import('./providers/lista/Table')),
    },
    {
        path: '/configuracoes/recompensas',
        exact: true,
        component: React.lazy(() => import('./recompensas/lista/Table')),
    },
    {
        path: '/configuracoes/listas',
        exact: true,
        component: React.lazy(() => import('./listas/lista/Table')),
    },
    {
        path: '/configuracoes/listas/novo',
        exact: true,
        component: React.lazy(() => import('./listas/form/Form')),
    },
]

export default clientesRoutes
